var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpoutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.4,
    height: 19.4,
    viewBox: "0 0 20.4 20.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "helpoutlineIcon",
    transform: "translate(52.67 -9.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12753",
    "data-name": "Group 12753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M-34.06,14.88a9.638,9.638,0,0,0-1.55-2.04A9.64,9.64,0,0,0-42.47,10a9.712,9.712,0,0,0-5.56,1.75,9.7,9.7,0,0,0-4.14,7.95,9.7,9.7,0,0,0,4.14,7.95,9.712,9.712,0,0,0,5.56,1.75,9.684,9.684,0,0,0,8.41-4.87,9.63,9.63,0,0,0,1.29-4.83A9.592,9.592,0,0,0-34.06,14.88Z",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11082",
    "data-name": "Path 11082",
    d: "M-38.92,16.8a2.768,2.768,0,0,1-.36,1.49,6.069,6.069,0,0,1-1.08,1.29,3.957,3.957,0,0,0-.77.91,1.89,1.89,0,0,0-.2.96v.26h-2.19v-.54a2.768,2.768,0,0,1,.34-1.38,6.035,6.035,0,0,1,1.19-1.33,3.715,3.715,0,0,0,.71-.77,1.416,1.416,0,0,0,.23-.77,1.151,1.151,0,0,0-.38-.87,1.4,1.4,0,0,0-1.01-.36,1.558,1.558,0,0,0-1.09.39,2.18,2.18,0,0,0-.6.97l-1.9-.8a3.667,3.667,0,0,1,1.22-1.82,3.514,3.514,0,0,1,2.31-.78,4.149,4.149,0,0,1,1.86.42,3.2,3.2,0,0,1,1.26,1.13A3.034,3.034,0,0,1-38.92,16.8Z",
    fill: "var(--mainColor)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11083",
    "data-name": "Path 11083",
    d: "M-41.02,24.33v.02a1.4,1.4,0,0,1-.41,1.02,1.366,1.366,0,0,1-1.01.42,1.44,1.44,0,0,1-1.44-1.44,1.357,1.357,0,0,1,.41-1.01,1.366,1.366,0,0,1,1.02-.42A1.419,1.419,0,0,1-41.02,24.33Z",
    fill: "var(--mainColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpoutlineIcon);
export default __webpack_public_path__ + "static/media/helpoutlineIcon.e8515e19f5219b0c882bf222b4910944.svg";
export { ForwardRef as ReactComponent };